//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vSelect from 'vue-select'
import ValidationMessages from './ValidationMessages.vue'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'InputTags',
  components: {
    ValidationMessages,
    vSelect
  },
  props: {
    label: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    optionsLabel: {
      type: String,
      default: 'label'
    },
    value: {
      type: Array,
      default () {
        return []
      }
    },
    placeholder: {
      type: String,
      default: null
    },
    validation: {
      type: Object,
      default: null
    },
    reduce: {
      type: Function,
      default: i => i
    }
  },
  computed: {
    classes () {
      return this.validation && this.validation.$dirty && this.validation.$invalid
        ? 'is-invalid'
        : ''
    }
  }
}
